<template>
    <div class="page" id="mixed-notes">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" background-color="#EBF9FF"
            color="#02B99E">
        </loading>
        <div class="decorative-texture top">
            <img :src="require(`@/assets/img/texture.png`)" />
        </div>
        <div class="decorative-texture position-bottom movil-only">
            <img :src="require(`@/assets/img/texture.png`)" />
        </div>
        <vue-snotify></vue-snotify>
        <side-menu :menuOn="menuOn" @menuVisible="menuVisible"></side-menu>
        <mnavbar @menuVisible="menuVisible"></mnavbar>
        <div id="page-content-wrapper" v-if="form.nombre != ''">
            <div class="container-fluid noPadding">
                <div class="toolBar">
                    <div class="row">
                        <div class="col">
                            <h2 class="toolBarTitle">{{ form.nombre }}</h2>
                        </div>
                        <div class="toolActions col-auto">
                            <div class="separator"></div>
                            <div class="keywords">
                                <button class="button back-button buttonTool tooltip" data-tooltip="regresar"
                                    @click="goBack">
                                    <svg width="10.975" height="9.998" viewBox="0 0 10.975 9.998">
                                        <path id="Color_Overlay" data-name="Color Overlay"
                                            d="M26.825,57.835l-3.549-4.046A.634.634,0,0,1,23,53.244v-.366a.7.7,0,0,1,.068-.308.641.641,0,0,1,.14-.282l3.615-4.122a.439.439,0,0,1,.706.028l.205.267a.706.706,0,0,1-.023.861L25.13,52.268h8.343a.564.564,0,0,1,.5.609v.366a.564.564,0,0,1-.5.609H25.236l2.478,2.825a.708.708,0,0,1,.023.861l-.205.266a.462.462,0,0,1-.365.194A.455.455,0,0,1,26.825,57.835Z"
                                            transform="translate(-23 -48.001)" />
                                    </svg>
                                </button>
                                <button class="button back-button buttonTool tooltip" data-tooltip="Editar"
                                    @click="showeditarName">
                                    <font-awesome-icon icon="edit" style="color:#fff; height:15px" /></button>

                                <button class="button back-button buttonTool tooltip" data-tooltip="Eliminar Carpeta">
                                    <font-awesome-icon icon="trash-alt" style="color:#fff; height:15px"
                                        @click="mostrarDeleteCarpet" /></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center m-2">
                    <div class="col-sm-12 col-md-10 col-lg-10 col-xl-7">
                        <!-- <section class="noPadding"> -->
                        <div class="iframe-container">
                            <section class="noPadding">
                                <div class="row justify-content-center" style="margin-top: 2%">
                                    <div class="col-sm-12 col-md-11 col-lg-10">
                                        <div class="card head-card keywords-section">
                                            <div class="title-card">
                                                <h4>NewsLetter</h4>
                                            </div>

                                            <div class="card-content">
                                                <div class="row justify-content-center">
                                                    <div class="col-sm-12 col-md-8 mb-1 justify-content-center"
                                                        v-if="form.url != '' && form.url != null">
                                                        <img v-if="form.url != '' && form.url != null" id="imagen"
                                                            :src="form.url" width="40%" height="70%" alt="Imagen" />
                                                    </div>

                                                    <div class="col-sm-12 col-md-8 mb-2">
                                                        <div class="Keywords-button-container">

                                                            <button :class="[
                                                                'button',
                                                                'fluid',
                                                                'alternative',
                                                                'noMargin',
                                                            ]" @click="showModalImagen">Elegir Imagen</button>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 col-md-8 mb-2">
                                                        <div class="inputype Keywords-input">
                                                            <form>
                                                                <h4 class="interiorTitle">Titulo</h4>
                                                                <input type="text " v-model="form.titulo"
                                                                    placeholder="Titulo" />
                                                            </form>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 col-md-8 mb-2">
                                                        <div class="inputype Keywords-input">
                                                            <form>
                                                                <h4 class="interiorTitle">Subtítulo 1 </h4>
                                                                <input type="text " v-model="form.subtituloA0"
                                                                    placeholder="Subtítulo 1" />
                                                                <h4 class="interiorTitle">Subtítulo 2</h4>
                                                                <input type="text " v-model="form.subtituloA1"
                                                                    placeholder="Subtítulo 2" />
                                                                <h4 class="interiorTitle">Subtítulo 3</h4>
                                                                <input type="text " v-model="form.subtituloA2"
                                                                    placeholder="Subtítulo 3" />
                                                                <h4 class="interiorTitle">Subtítulo 4</h4>
                                                                <input type="text " v-model="form.subtituloA3"
                                                                    placeholder="Subtítulo 4" />
                                                                <h4 class="interiorTitle">Subtítulo 5</h4>
                                                                <input type="text " v-model="form.subtituloA4"
                                                                    placeholder="Subtítulo 5" />
                                                            </form>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 col-md-8 container mb-2">
                                                        <div class="inputype Keywords-input">
                                                            <form>
                                                                <h4 class="interiorTitle">Fecha</h4>
                                                                <VueDatePicker v-model="range" range color="#00b99e" />
                                                            </form>
                                                        </div>

                                                    </div>

                                                    <div class="col-sm-12 col-md-8 mb-2">
                                                        <div class="inputype Keywords-input">
                                                            <form>
                                                                <h4 class="interiorTitle">
                                                                    Fondo del documento
                                                                </h4>
                                                                <input :style="'background-color:' +
                                                                    form.color +
                                                                    '; border: 2px solid black' +
                                                                    form.color
                                                                    " id="color-picker" type="color"
                                                                    v-model="form.color" placeholder="Color"
                                                                    @input="updateColor" />
                                                            </form>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 col-md-8 mb-2">
                                                        <div class="row justify-content-center">
                                                            <div class="col-sm-6 col-md-6 mb-2">
                                                                <div class="Keywords-button-container">
                                                                    <button :class="[
                                                                        'button',
                                                                        'fluid',
                                                                        'alternative',
                                                                        'noMargin',
                                                                    ]" @click="guardarCambios()">
                                                                        Guardar
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6 col-md-6 mb-2">
                                                                <div class="Keywords-button-container">
                                                                    <button :class="[
                                                                        'button',
                                                                        'fluid',
                                                                        'alternative',
                                                                        'noMargin',
                                                                    ]" @click="generar_pdf"
                                                                        :aria-readonly="form.titulo == ''">
                                                                        Generar PDF
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            <div class="col-sm-6 col-md-6 mb-2">
                                                                <div class="Keywords-button-container">
                                                                    <button :class="[
                                                                        'button',
                                                                        'fluid',
                                                                        'alternative',
                                                                        'noMargin',
                                                                    ]" @click="abrir">
                                                                        Vista previa
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <!-- </section> -->
                    </div>
                    <div class="col-lg-10 col-sm-12 col-md-12 col-xs-12">
                        <span v-for="(itemsNoticias, index) in noticias" :key="index" class="title-sub"> {{ index }}
                        <timeline from="newsletter" :items="itemsNoticias" :LastEvaluatedKey="0" @goToNoteTimeline="goToNote"
                            @loadMore="loadMore" @borrar="showModalDelete" :actualizarList="actualizarList"></timeline>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <vistaPrevia v-if="url_pdf != ''" :active="mostrarModal" :close="showCloseModal" :url="url_pdf"></vistaPrevia>
        <confirm-modal smsModal="Realmente, ¿Desea eliminar ésta nota de newsletter?" :show="showModal"
            @cancelar="hideModal" @aceptar="borrar"></confirm-modal>

        <confirm-modal smsModal="Realmente, ¿Desea eliminar este newsletter?" :show="showDeleteFolder"
            @cancelar="mostrarDeleteCarpet" @aceptar="eliminarCarpeta"></confirm-modal>

        <modalNewsletter :name="form.nombre" :active="editarNombre" :close="showeditarName" :reload="get_newsletter"
            :edit="true" v-if="form.nombre != ''" :id="id" />

        <modalImagen :active="modalImagen" :cancelar="showModalImagen" :guardar="uploadImage" :error="error"
            :imagenAnterior="form.url" />

    </div>
</template>
  
<script>
import confirmModal from "@/components/confirm";
import SideMenu from "@/components/sideMenu";
import mnavbar from "@/components/mnavbar";
// import panelNotas from "@/components/panelNotas";
import timeline from "./components/timelinenewsletter.vue";
import vistaPrevia from "./components/vistaPrevia.vue";
import modalNewsletter from "./components/modalAgregarnewsletter.vue";
import modalImagen from "./components/imagen.vue";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import moment from "moment";

import { VueDatePicker } from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';

// iconos
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPaperPlane, faEdit, faTrashAlt, faSearch, faTh } from "@fortawesome/free-solid-svg-icons";
library.add(faPaperPlane);
library.add(faEdit);
library.add(faTrashAlt);
library.add(faSearch);
library.add(faTh);

export default {
    props: ['id'],
    components: {
        SideMenu,
        mnavbar,
        confirmModal,
        // panelNotas,
        timeline,
        vistaPrevia,
        modalNewsletter,
        VueTimepicker,
        VueDatePicker,
        modalImagen,
    },
    data() {
        return {
            selectedDate: null,
            api: "https://4x5kpq7d6g.execute-api.us-east-1.amazonaws.com/v2/getnewsletter",
            iframeUrl: "http://localhost:8082",
            url: this.$store.getters.getMainUrl,
            menuOn: false,
            form: {
                titulo: "",
                color: "#cbd5e0",
                file: null,
                url: "",
                key: this.id,
                height: 0,
                width: 0,
                nombre: "",
                id: this.id,
                subtitulo: "",
                rango: '',
                start: "",
                end: "",
            },
            defaultForm: {
                titulo: "",
                color: "#cbd5e0",
                file: null,
                url: "",
                key: this.id,
                height: 0,
                width: 0,
                nombre: "",
                id: this.id,
                subtitulo: "",
                rango: "",
                start: "",
                end: "",
            },
            noticias: [],
            view: 1,
            LastEvaluatedKey: 1,
            isLoading: false,
            mostrarModal: false,
            url_pdf: "",
            showModal: false,
            noticiaD: null,
            imagenSelect: null,
            showDeleteFolder: false,
            editarNombre: false,
            range: {
                start: null, // Jan 16th, 2018
                end: null // Jan 19th, 2018
            },
            start: null,
            end: null,
            modalImagen: false,
        };
    },
    mounted() {
        console.log(this.$store.state.userInfo);
        this.get_newsletter();
    },
    methods: {
        menuVisible(menu) {
            this.hide = true;
            this.menuOn = menu;
        },
        updateColor(event) {
            this.form.color = event.target.value;
        },
        uploadImage(event) {
            console.log(event);
            const imagen = event;

            if (imagen) {
                const fileExtension = imagen.name.split(".").pop();
                console.log(fileExtension);
                // this.form.file = imagen;
                if (fileExtension == "png" || fileExtension == "jpg" || fileExtension == "jpeg") {
                    const reader = new FileReader();

                    reader.onload = async () => {
                        this.form.url = reader.result;
                        this.form.file = btoa(reader.result);
                        await this.valildDimensiones(this.form.url);
                    };

                    reader.readAsDataURL(imagen);
                } else {
                    document.getElementById("logoNewsletter").value = "";
                    this.form.url = null;
                    this.form.file = null;
                    this.error("Solo se admite formato png, jpg y jpeg");
                }
            }
            this.showModalImagen();
        },
        async get_newsletter() {
            this.form = Object.assign({}, this.defaultForm);
            // document.getElementById("logoNewsletter").value = "";
            this.isLoading = true;
            var post_data = {
                key: this.id,
            };
            await axios
                .post(this.url + "getnewslettername", post_data) //petición
                .then((response) => {
                    console.log(response.data);
                    var item = response.data.newsletter;
                    if (item) {
                        this.form.titulo = item.titulo;
                        this.form.url = item.logo;
                        this.form.color = item.fondo;
                        this.form.width = item.width;
                        this.form.height = item.height;
                        this.form.nombre = item.nombre;
                        //this.form.subtitulo = item.subtitulo; //EGM20260324
                        for (let i = 0; i < item.subtitulos.length; i++) {
                            this.form[`subtituloA${i}`] = item.subtitulos[i];
                        }
                        this.noticias = response.data.notas;
                        var ini = this.cambiarFormato(item.start);
                        var fin = this.cambiarFormato(item.end);
                        console.log("finalizacion", fin, item.end);
                        this.form.start = ini;
                        this.form.end = fin;
                        this.range.start = ini;
                        this.range.end = fin
                        this.start = ini;
                        this.end = fin;

                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.isLoading = false;
        },
        goToNote(obj) {
            console.log(obj);
            var name = "";
            var fi = obj.fi ? obj.fi : obj.entrada;
            switch (fi) {
                case "FB":
                case "I":
                case "TW":
                    name = "notaEmbedded"; //este ya esta NotaEmbeddedLayoutDesktop
                    break;
                case "Y":
                    name = "notaYoutube"; //este ya esta NotaVideoLayoutDesktop
                    break;
                case "PD":
                    name = "notaText"; //este ya esta notaTextLayoutDesktop
                    break;
                case "T":
                case "R":
                    name = "notaVideo"; // NotaVideoLayoutDesktop
                    break;
                case "TK":
                    name = "notaTk"; // NotaVideoLayoutDesktop
                    break;
            }

            var p = {
                from: "newsletter",
            };
            this.$store.commit("saveBack2", p);

            var params = {
                id: obj.id ? obj.id : obj.key,
                fi: fi,
            };

            if (fi == "TK") {
                params = {
                    id:  obj.key,
                    fi: fi,
                };
            }

            this.$router.push({ name: name, params: params });
        },
        goToNotes() { },
        loadMore() { },
        async borrar() {
            console.log("borrar");
            var item = this.noticiaD;
            console.log("item", item.item.key);
            this.isLoading = true;
            var post_data = {
                table: this.id,
                id: item.item.key,
            };

            await axios
                .post(
                    this.url + "deleteItemNewsletter",
                    post_data
                ) //petición
                .then((response) => { })
                .catch(function (error) {
                    console.log(error);
                });
            this.hideModal();
            this.isLoading = false;

            this.get_newsletter();
        },
        async generar_pdf(mostrarMessage = true) {
            var query = {
                key: this.id,
                flag: true,
                dev: false,
            };
            this.isLoading = true;
            await axios
                .post(
                    this.url + "generar_pdf_newsletter",
                    query
                )
                .then((response) => {
                    if (response.data.success) {
                        this.url_pdf = response.data.link;
                        if (mostrarMessage) {
                            this.success("Generado correctamente");
                            window.open(response.data.link);
                        }

                        // this.get_newsletter();
                    } else {
                        if (mostrarMessage) {
                            this.error("Intente nuevamente");
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.isLoading = false;
        },

        async guardarCambios(mostrarMessage = true) {
            if (this.range.start && this.range.end) {
                await this.formatFecha(this.range);
            }
            if (this.form.file) {
                const img = new Image();
                img.onload = async () => { };
                img.src = this.form.url;
                console.log(`${img.width} ${img.height}`);
                this.form.width = img.width;
                this.form.height = img.height;
            }
            this.form.lista = this.noticias;
            this.form.flag = true;
            this.isLoading = true;

            await axios
                .post(
                    this.url + "createeditnewletter",
                    this.form
                )
                .then((response) => {
                    if (response.data.success) {
                        if (mostrarMessage) {
                            this.success(response.data.body);
                            this.form = Object.assign({}, this.defaultForm);
                            // this.get_newsletter();
                            location.reload();
                        }
                    } else {
                        if (mostrarMessage) {
                            this.error(response.data.body);
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.isLoading = false;
        },
        success(msg) {
            this.$snotify.success(msg, this.$store.state.success);
        },
        error(msg) {
            this.$snotify.error(msg, this.$store.state.error);
        },
        showCloseModal() {
            this.mostrarModal = !this.mostrarModal;
            if (!this.mostrarModal) {
                this.url_pdf = "";
            }
            // this.guardarCambios();
        },
        async abrir() {
            await this.vista_previa();
            this.showCloseModal();
        },
        async vista_previa() {
            if (this.range.start && this.range.end) {
                await this.formatFecha(this.range);
            }

            if (this.form.file) {
                const img = new Image();
                img.onload = async () => { };
                img.src = this.form.url;
                console.log(`${img.width} ${img.height}`);
                this.form.width = img.width;
                this.form.height = img.height;

            }

            this.isLoading = true;
            var query = this.form;
            (query.lista = this.noticias),
                await axios
                    .post(this.url + "vista_previa_newsletter",
                        query
                    )
                    .then((response) => {
                        if (response.data.success) {
                            this.url_pdf = response.data.url;
                            // this.showCloseModal();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            this.isLoading = false;
        },
        hideModal() {
            this.showModal = false;
            this.noticiaD = null;
        },
        showModalDelete(itemD) {
            this.noticiaD = itemD;
            this.showModal = true;
        },
        async valildDimensiones(imagen) {
            console.log("hola we", imagen);
            const img = new Image();
            img.onload = async () => {
                await console.log(img.width);
                console.log(img.width, img.height);
                if (img.width > 600 || img.height > 200) {
                    document.getElementById("logoNewsletter").value = "";
                    this.form.url = null;
                    this.form.file = null;
                    this.error("El archivo debe tener un tamaño máximo de 600x200");
                }
            };
            img.src = imagen;


        },
        actualizarList(newList) {
            this.noticias = newList;
        },
        goBack() {
            this.$router.push({ name: 'newsletter' });
        },
        async eliminarCarpeta() {

            this.isLoading = true;
            var post_data = {
                table: "newsletter",
                id: this.id,
                padre: true,
            };

            await axios
                .post(this.url + "deleteItemNewsletter",
                    post_data
                ) //petición
                .then((response) => {
                    this.$router.push({ name: 'newsletter' });
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.mostrarDeleteCarpet();
            this.isLoading = false;
        },
        async mostrarDeleteCarpet() {
            this.showDeleteFolder = !this.showDeleteFolder;
        },
        async showeditarName() {
            this.editarNombre = !this.editarNombre;
        },

        async formatFecha() {
            console.log("===", this.range);
            var dateStart = new Date(this.range.start.replace(/-/g, "/"));
            var dateEnd = new Date(this.range.end.replace(/-/g, "/"));

            // inicial,
            var dia = dateStart.getDate();
            var mes = dateStart.getMonth() + 1;
            var anio = dateStart.getFullYear();
            dia = dia < 9 ? "0" + dia : dia;
            mes = mes < 9 ? "0" + mes : mes;
            this.start = dia + '/' + mes + '/' + anio;

            // final 
            dia = dateEnd.getDate();
            mes = dateEnd.getMonth() + 1;
            anio = dateEnd.getFullYear();
            dia = dia < 10 ? "0" + dia : dia;
            mes = mes < 10 ? "0" + mes : mes;
            this.end = dia + '/' + mes + '/' + anio;

            this.form.rango = `Del ${this.start} al ${this.end}`
            if (this.start == this.end) {
                this.form.rango = this.start
            }
            this.form.end = this.end;
            this.form.start = this.start;
            console.log(this.form);

            return;

        },

        cambiarFormato(fecha) {
            console.log(fecha, "llega la fecha");
            var f = fecha.split('/');
            var dateStart = new Date(f[2] + "/" + f[1] + "/" + f[0]);

            console.log(dateStart, "trasform-date");

            var dia = dateStart.getDate();
            var mes = dateStart.getMonth() + 1;
            var anio = dateStart.getFullYear();
            dia = dia < 9 ? "0" + dia : dia;
            mes = mes < 9 ? "0" + mes : mes;
            var f = anio + '-' + mes + '-' + dia;
            console.log(f, "fecha generada");
            return f;
        },
        showModalImagen() {
            this.modalImagen = !this.modalImagen;
        }

    },
    computed: {
        getMinDate() {
            var today = moment();
            var minF = today.subtract(60, 'days');
            var minDate = new Date(minF);
            return minDate;
        },
    },
    watch: {
        range(val) {
            console.log('range changed', val)
            if (val) {
                let d = new Date(val.start);
                let de = new Date(val.end);
                let ms = d.getMonth() + 1;
                let me = de.getMonth() + 1;
                if (ms <= 9) ms = '0' + ms;
                if (me <= 9) me = '0' + me;

                let ds = d.getDate();
                let dend = de.getDate();

                if (ds <= 9) ds = '0' + ds;
                if (dend <= 9) dend = '0' + dend;

                this.start = ds + "/" + ms + "/" + d.getFullYear();
                this.end = dend + "/" + me + "/" + de.getFullYear();

                var dates = {
                    ini: d.getFullYear() + '-' + ms + '-' + ds,
                    fin: de.getFullYear() + '-' + me + '-' + dend,
                }
                this.$store.commit("addRange", dates);
                this.form.rango = `Del ${this.start} al ${this.end}`
                this.form.start = this.start;
                this.form.end = this.end;
                if (this.start == this.end) {
                    this.form.rango = `${this.start}`;
                }

            }
        },

    }
};
</script>
<style>

.title-sub {
  color: #00b99e;
  font-size: 18px;
}

.keywords-section .Keywords-input input {
    border: 1px solid #00b99e;
}

.keywords-section .Keywords-input input::placeholder {
    color: #062633;
}

.buttonTool {
    color: #fff;
    background: #00b99e;
    border-radius: 5px;
    border: none;
    padding: 5px 9px;
    font-size: 16px;
}

.buttonTool:hover {
    color: #062633;
    background: #ebf9ff;
    border-radius: 5px;
    border: none;
    padding: 5px 9px;
    font-size: 16px;
    z-index: 99999;
}

.button.tooltip:after {
    z-index: 9999999999;
}

[type="radio"]:checked,
[type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
}

[type="radio"]:checked+label,
[type="radio"]:not(:checked)+label {
    position: relative;
    padding-left: 20px;
    padding-right: 10px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #ebf9ff;
}

[type="radio"]:checked+label:before,
[type="radio"]:not(:checked)+label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #00b99e;
    border-radius: 100%;
    background: #ebf9ff;
}

[type="radio"]:checked+label:after,
[type="radio"]:not(:checked)+label:after {
    content: '';
    width: 18px;
    height: 18px;
    background: #00b99e;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
}

[type="radio"]:not(:checked)+label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
}

[type="radio"]:checked+label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}
</style>